import React from "react";
 
const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Privacy Policy</h1>
      <p><strong>Last Updated:</strong> December 04, 2024</p>
      <p>
        Niramaya Homeopathy Clinic and Research Centre ("Niramaya Homeopathy," "Company," "We," "Our," or "Us") is committed to respecting and protecting your privacy. This Privacy Policy outlines how we collect, use, and protect your data when you visit and use <a href="https://www.niramayahomoeopathy.com/">https://www.niramayahomoeopathy.com/</a> (the "Website") and its related services (the "Services"). By using our Website, you agree to the terms outlined in this Privacy Policy. If you do not agree, please refrain from using our Services.
      </p>
     
      <h2>Information We Collect</h2>
      <h3>1. Personal Information</h3>
      <p>
        This includes information that identifies you personally, such as:
        <ul>
          <li>Name, Address, and Contact Details: Required to provide consultations, respond to inquiries, or process payments.</li>
          <li>Health Information: Includes medical records, history, and any data shared during consultations.</li>
          <li>Login Credentials: Username and password created during registration.</li>
          <li>Payment Details: When you make a payment, we collect billing information.</li>
        </ul>
      </p>
 
      <h3>2. Non-Personal Information</h3>
      <p>
        This includes:
        <ul>
          <li>Browser type, device details, operating system, and usage data such as session frequency and duration.</li>
          <li>Internet Protocol (IP) address and cookies for tracking user behavior and enhancing user experience.</li>
        </ul>
      </p>
 
      <h3>3. Permissions</h3>
      <p>
        When using specific features (e.g., uploading files or video consultations), we may request access to your device's camera, microphone, or contacts.
      </p>
 
      <h2>Use of Collected Information</h2>
      <p>We use your information to:</p>
      <ul>
        <li>Provide homeopathic consultation services.</li>
        <li>Personalize user experiences on our Website.</li>
        <li>Respond to your queries and provide customer support.</li>
        <li>Improve and optimize our Website and Services.</li>
        <li>Comply with legal and regulatory requirements.</li>
      </ul>
      <p>
        With your explicit consent, we may also use your data for testimonials, educational purposes, or statistical analysis, ensuring no personally identifiable information is disclosed.
      </p>
 
      <h2>Cookies and Tracking Technology</h2>
      <h3>1. Types of Cookies Used:</h3>
      <ul>
        <li>Essential Cookies: Required for core functionalities like user authentication.</li>
        <li>Functional Cookies: Enhance user experience by remembering preferences.</li>
        <li>Analytics Cookies: Help us understand user behavior and improve our Website.</li>
        <li>Advertising Cookies: Facilitate relevant advertisements through third-party services.</li>
      </ul>
      <h3>2. Managing Cookies:</h3>
      <p>
        You can control cookies via your browser settings. Please note that disabling cookies may affect Website functionality.
      </p>
 
      <h2>Information Sharing and Disclosure</h2>
      <p>
        We do not sell, rent, or share your personal information with third parties for marketing purposes without your consent. However, we may disclose your information in the following cases:
        <ul>
          <li><strong>Legal Obligations:</strong> To comply with court orders, subpoenas, or other legal processes.</li>
          <li><strong>Mergers or Acquisitions:</strong> If the Company is merged with or acquired by another entity, your data may be transferred.</li>
          <li><strong>Third-Party Services:</strong> Payment processors like Razorpay handle your payment transactions securely. Refer to their privacy policy for details.</li>
        </ul>
      </p>
 
      <h2>Security of Your Data</h2>
      <p>
        We use industry-standard security measures to safeguard your information, including:
        <ul>
          <li>Encryption of sensitive data during transmission.</li>
          <li>Secure access controls for authorized personnel only.</li>
          <li>Regular updates to systems and software to mitigate security risks.</li>
        </ul>
      </p>
 
      <h2>Your Rights</h2>
      <p>
        You have the following rights regarding your personal data:
        <ul>
          <li><strong>Access:</strong> Request a copy of the data we hold about you.</li>
          <li><strong>Correction:</strong> Update inaccurate or incomplete data.</li>
          <li><strong>Deletion:</strong> Request deletion of your data under applicable laws.</li>
          <li><strong>Opt-Out:</strong> Unsubscribe from promotional communications by following instructions in our emails or contacting us directly.</li>
        </ul>
      </p>
 
      <h2>Third-Party Links and Services</h2>
      <p>
        Our Website may contain links to third-party websites. This Privacy Policy does not apply to those sites, and we encourage you to review their privacy policies before sharing any information.
      </p>
 
      <h2>Privacy of Minors</h2>
      <p>
        By using this Website, you confirm that you are at least the age of majority in your jurisdiction. If minors use our Services, it is presumed to be with parental or guardian consent.
      </p>
 
      <h2>Testimonials and Consent</h2>
      <p>
        We may use anonymized information for educational purposes or testimonials. If a photo, name, or identifiable data is used, explicit consent will be obtained unless the information does not compromise confidentiality (e.g., images of a specific body part unrelated to identity).
      </p>
 
      <h2>Changes to this Privacy Policy</h2>
      <p>
        We reserve the right to update this Privacy Policy periodically. Any changes will be posted on this page with the "Last Updated" date revised accordingly. Continued use of our Services after updates constitutes acceptance of the revised policy.
      </p>
 
      <h2>Contact Us</h2>
      <p>
        If you have any questions, complaints, or suggestions regarding this Privacy Policy or how your data is handled, please contact us at:
        <ul>
          <li><strong>Company Name:</strong> Niramaya Homeopathy Clinic and Research Centre</li>
          <li><strong>Website:</strong> <a href="https://www.niramayahomoeopathy.com/">https://www.niramayahomoeopathy.com/</a></li>
          <li><strong>Email:</strong> niramayaforyou@gmail.com</li>
          <li><strong>Phone:</strong> +919236185711</li>
          <li><strong>Address:</strong> 0230-B Civil Lines 2, Near DIG Bungalow, Bilandpur, Gorakhpur</li>
        </ul>
      </p>
    </div>
  );
};
 
export default PrivacyPolicy;